import { Box, Grid, Icon, Typography } from "@mui/material";
import React, { useState } from "react";

const servicesss = [
  {
    id: 1,
    name: "Haircut and styling",
    iconName: "content_cut_icon",
    selected: false,
  },
  {
    id: 2,
    name: "Nails services",
    iconName: "health_and_safety",
    selected: false,
  },
  {
    id: 3,
    name: "Eyebrows and eyelashes",
    iconName: "visibility",
    selected: false,
  },
  {
    id: 4,
    name: "Facials and skin care treatments",
    iconName: "local_dining",
    selected: false,
  },
  { id: 5, name: "Injection and fillers", iconName: "chair", selected: false },
  { id: 6, name: "Makeup", iconName: "fitness_center", selected: false },
  { id: 7, name: "Shaving", iconName: "fitness_center", selected: false },
  { id: 8, name: "Massage", iconName: "fitness_center", selected: false },
  { id: 9, name: "Hair Removal", iconName: "fitness_center", selected: false },
];

const StepTwo = ({ selectedServices, setSelectedServices }) => {
  const [servicesData, setServicesData] = useState(servicesss);

  const handleSelectService = (item, index) => {
    let tempArr = [...servicesData];
    let tempSelected = [...selectedServices];

    if (item.selected) {
      // Remove selected item from list
      tempArr[index].selected = false;
      tempSelected = tempSelected.filter((service) => service.id !== item.id);
    } else {
      // Add selected item to list
      tempArr[index].selected = true;
      tempSelected.push(item);
    }

    setServicesData(tempArr);
    setSelectedServices(tempSelected);
  };

  return (
    <Box>
      <Grid container justifyContent={"center"}>
        <Grid item xs={12} sm={7}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: "400",
              fontSize: "14px",
              marginBottom: "15px",
              color: "rgb(178 181 178)",
            }}
          >
            Account Setup
          </Typography>
          <Typography
            variant="h3"
            sx={{ fontWeight: "700", fontSize: "30px", marginBottom: "15px" }}
          >
            What services do you offer?
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontWeight: "400",
              fontSize: "15px",
              marginBottom: "15px",
              color: "rgb(178 181 178)",
            }}
          >
            Choose your primary and up to 3 related service types
          </Typography>

          <Grid container spacing={3}>
            {servicesData.map((item, index) => {
              const selectedIndex = selectedServices.findIndex(
                (s) => s.id === item.id
              );

              return (
                <Grid item xs={12} sm={6} md={4} key={item.id}>
                  <Box
                    sx={{
                      border: `2.5px solid ${
                        item.selected && selectedIndex !== -1
                          ? "#EA580C"
                          : "rgb(178 181 178)"
                      }`,
                      padding: "5px 10px",
                      borderRadius: "10px",
                      cursor: "pointer",
                      position: "relative",
                    }}
                    onClick={() => handleSelectService(item, index)}
                  >
                    {item.selected && selectedIndex !== -1 && (
                      <Box
                        sx={{
                          position: "absolute",
                          right: 10,
                          top: 5,
                          background: "blue",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          ...(selectedIndex === 0 && {
                            padding: "6px 10px",
                            borderRadius: "10px",
                          }),
                          ...(selectedIndex !== 0 && {
                            width: "25px",
                            height: "25px",
                            borderRadius: "50%",
                          }),
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "700",
                            color: "#fff",
                            fontSize: "10px",
                          }}
                        >
                          {selectedIndex === 0 ? "Primary" : selectedIndex + 1}
                        </Typography>
                      </Box>
                    )}
                    <Icon sx={{ fontSize: "35px" }}>{item.iconName}</Icon>
                    <Typography
                      sx={{
                        fontSize: 12,
                        marginTop: "10px",
                        fontWeight: "700",
                      }}
                    >
                      {item.name}
                    </Typography>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StepTwo;
